import { TransactionStatusUseCase } from '../../../application';

export default class TransactionStatusService {
    constructor() {}

    async execute(event) {
        const request = await TransactionStatusUseCase(event);

        return request;
    }
}
